/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ParameterKind = {
    CurrentTimestamp: 'CURRENT_TIMESTAMP',
    ConversationData: 'CONVERSATION_DATA',
    ConversationDataTimestamp: 'CONVERSATION_DATA_TIMESTAMP',
    ConversationDataTime: 'CONVERSATION_DATA_TIME',
    AppUrl: 'APP_URL',
    WorkflowId: 'WORKFLOW_ID',
    Error: 'ERROR',
    Domain: 'DOMAIN'
} as const;
export type ParameterKind = typeof ParameterKind[keyof typeof ParameterKind];


export function instanceOfParameterKind(value: any): boolean {
    for (const key in ParameterKind) {
        if (Object.prototype.hasOwnProperty.call(ParameterKind, key)) {
            if (ParameterKind[key as keyof typeof ParameterKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ParameterKindFromJSON(json: any): ParameterKind {
    return ParameterKindFromJSONTyped(json, false);
}

export function ParameterKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParameterKind {
    return json as ParameterKind;
}

export function ParameterKindToJSON(value?: ParameterKind | null): any {
    return value as any;
}

export function ParameterKindToJSONTyped(value: any, ignoreDiscriminator: boolean): ParameterKind {
    return value as ParameterKind;
}

